<script>
  import CreateView from '../partials/CreateView.vue'
  import FormInput from '../form/form-input.vue'
  import FormRepositoryAuth from '../form/form-repository-auth.vue'
  import tokenMixin from '../form/token-mixin.js'

  import {
    BButton,
    BInputGroupAppend,
  } from 'bootstrap-vue'

  export default {
    components: {
      BButton,
      BInputGroupAppend,
      CreateView,
      FormInput,
      FormRepositoryAuth,
    },
    mixins: [
      tokenMixin
    ],
  }
</script>
<template>
  <create-view
    v-slot="slotProps"
    store="packagedescriptorauth"
    update-route="PackageDescriptorAuthUpdate"
  >
    <form-input
      :store="slotProps.store"
      prop-name="name"
      class="col-6"
    />
    <form-repository-auth
      :store="slotProps.store"
      prop-name="auth"
      class="col-12"
    />
    <form-input
      :store="slotProps.store"
      prop-name="webHookToken"
      class="col-6"
    >
      <b-input-group-append>
        <b-button
          :title="$t('packagedescriptorauth.webHookToken.generateTitle')"
          @click="$store.dispatch('packagedescriptorauth/create/updateItem', {webHookToken: random()})"
        >
          <font-awesome-icon :icon="iconRandom" />
        </b-button>
      </b-input-group-append>
    </form-input>
  </create-view>
</template>
